var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.0001C9 11.7958 9.31607 12.5588 9.87868 13.1214C10.4413 13.6841 11.2044 14.0001 12 14.0001C12.7956 14.0001 13.5587 13.6841 14.1213 13.1214C14.6839 12.5588 15 11.7958 15 11.0001C15 10.2045 14.6839 9.44141 14.1213 8.8788C13.5587 8.31619 12.7956 8.00012 12 8.00012C11.2044 8.00012 10.4413 8.31619 9.87868 8.8788C9.31607 9.44141 9 10.2045 9 11.0001Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.657 16.6571L13.414 20.9001C13.039 21.2747 12.5306 21.4851 12.0005 21.4851C11.4704 21.4851 10.962 21.2747 10.587 20.9001L6.343 16.6571C5.22422 15.5382 4.46234 14.1128 4.15369 12.5609C3.84504 11.0091 4.00349 9.40059 4.60901 7.9388C5.21452 6.47702 6.2399 5.22761 7.55548 4.34858C8.87107 3.46955 10.4178 3.00037 12 3.00037C13.5822 3.00037 15.1289 3.46955 16.4445 4.34858C17.7601 5.22761 18.7855 6.47702 19.391 7.9388C19.9965 9.40059 20.155 11.0091 19.8463 12.5609C19.5377 14.1128 18.7758 15.5382 17.657 16.6571Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationAlt);
export default __webpack_public_path__ + "static/media/location_alt.b5330e6eba7f1ae17ffe051156df619f.svg";
export { ForwardRef as ReactComponent };